<ng-template #modal>
<div class="modal-header">
  <h4 class="modal-title me-3">{{ title | translate }}</h4>
  <button type="button" class="btn-close close pull-right" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true" class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  @if (description) {
    <p>{{ description | translate }}</p>
  }
  @if (form) {
    @for (keyValueForm of form.controls; track $index) {
      <div class="entity-group">
        <div class="row">
          <div class="col-md-6 form-group">
            <label>{{ 'dataconnection.endpoint.key' | translate }}</label>
            <app-input-with-error [control]="keyValueForm.controls.key"></app-input-with-error>
          </div>
          <div class="col-md-6 form-group">
            <label>{{ 'dataconnection.endpoint.value' | translate }}</label>
            <app-input-with-error [control]="keyValueForm.controls.value"></app-input-with-error>
          </div>
          <div class="col-md-12 mt-2">
            <button type="button" class="btn btn-outline-danger w-100" (click)="remove($index)"><span class="material-symbols-outlined">delete</span> {{ '' | translate }}</button>
          </div>
        </div>
      </div>
    }
  }
</div>
<div class="modal-footer">
  <div class="me-auto">
    <button type="button" class="btn btn-outline-success" (click)="add()"><span class="material-symbols-outlined">add</span> {{ '' | translate }}</button>
  </div>
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">{{ 'cancel' | translate }}</button>
  <button [disabled]="!form?.valid" type="button" class="btn btn-secondary" (click)="save()">{{'save' | translate}}</button>
</div>
</ng-template>
